module.exports = __webpack_public_path__ + "static/Ecosystem-icon-8-c64386ae9eb628cd189816149b12bf4e.png";